import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { fetchReviews } from "@/api";

export default function ReviewsSection() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchReviews().then(setReviews).catch(() => setReviews([]));
  }, []);

  if (reviews.length === 0) return null;

  return (
    <section data-testid="reviews-section" className="py-24 md:py-32 bg-[#0A1C45]">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-sky-300 font-bold mb-4">Word on the road</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-black text-white max-w-2xl mb-16">
            Drivers who made it theirs.
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.slice(0, 6).map((r, i) => (
            <Reveal key={r.id} delay={i * 0.08}>
              <div
                data-testid={`review-card-${i}`}
                className="h-full bg-[#122659] border border-sky-300/20 rounded-xl p-8 hover:border-[#F57C00]/50 transition-colors duration-300"
              >
                <Quote size={26} className="text-[#F57C00] mb-5" />
                <p className="text-sm text-slate-300 leading-relaxed mb-6">"{r.text}"</p>
                <div className="flex items-center justify-between">
                  <p className="font-display font-bold text-white text-sm">{r.name}</p>
                  <div className="flex gap-0.5" data-testid={`review-stars-${i}`}>
                    {[1, 2, 3, 4, 5].map((s) => (
                      <Star
                        key={s}
                        size={14}
                        className={s <= r.rating ? "text-[#F57C00] fill-[#F57C00]" : "text-slate-600"}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
